import { BaseAtlasRequest } from "../BaseAtlasRequest";
import { RegisterNewUserInterface } from "./register-new-user-interface";


export class RegisterNewUserRequest extends BaseAtlasRequest{
    public readonly operationName: string = "registernewuser";
    body: RegisterNewUserInterface;

    constructor(data){
        super()
        this.body = data;
        
    }
    
    /*public getBody() {
        throw new Error("Method not implemented.");
    }*/
}
